import React, { useState, useEffect } from 'react';
import MainMenu from './components/MainMenu/MainMenu';
import CreateGame from './components/CreateGame/CreateGame';
import PlayGame from './components/PlayGame/PlayGame';
import './index.css';

export const App: React.FC = () => {
  const [currentScreen, setCurrentScreen] = useState<'menu' | 'create' | 'play'>('menu');
  const [gameCode, setGameCode] = useState<string>('');

  // Check for URL parameters on load
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const codeParam = urlParams.get('code');

    if (codeParam) {
      setGameCode(codeParam);
      setCurrentScreen('play');
    }
  }, []);

  const navigateToCreate = () => setCurrentScreen('create');
  const navigateToPlay = () => setCurrentScreen('play');
  const navigateToMenu = () => setCurrentScreen('menu');
  const handleGameCreated = (code: string) => {
    setGameCode(code);
    setCurrentScreen('play');
  };

  return (
    <div className="h-screen w-screen overflow-hidden bg-[var(--primary)] font-raleway overflow-y-auto">
      <div className="w-full h-full flex items-center justify-center">
        <div className="w-full h-full max-w-full lg:max-w-6xl p-4 pt-5 flex flex-col md:flex-row">
          {currentScreen === 'menu' && (
            <MainMenu onCreateClick={navigateToCreate} onPlayClick={navigateToPlay} />
          )}
          {currentScreen === 'create' && (
            <CreateGame onGameCreated={handleGameCreated} onCancel={navigateToMenu} />
          )}
          {currentScreen === 'play' && (
            <PlayGame initialGameCode={gameCode} onBackToMenu={navigateToMenu} />
          )}
        </div>
      </div>
    </div>
  );
};

export default App;
